import React from 'react';

// Types
import { Icon as IconType } from '../../../types/icon';
import { Measurements } from '../../../types/measurements';

// Utils
import { getMeasurementBySize } from '../../../utils/icon';

// Component
import Icon from '../Icon/Icon';

const IconScreen: React.FC<IconType> = ({
  size,
  inverse,
  onClick,
  width,
  height,
  fill,
  iconClassName,
}) => {

  const defaultMeasurements: Measurements = {
    height: 14,
    width: 14,
  }

  const measurements = size ? getMeasurementBySize(size) : defaultMeasurements;

  return (
    <Icon inverse={inverse} onClick={onClick} className={iconClassName} classNameIconType="c-icon-screen">
      <svg width={width || measurements.width} height={height || measurements.height} viewBox="0 0 14 14" className="c-icon-screen fill-current" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.72 2.3296C13.874 2.3296 14 2.2036 14 2.0496C14 1.8956 13.874 1.7696 13.72 1.7696H12.2304V0.28C12.2304 0.126 12.1044 0 11.9504 0C11.7964 0 11.6704 0.126 11.6704 0.28V1.7696H2.3296V0.28C2.3296 0.126 2.2036 0 2.0496 0C1.8956 0 1.7696 0.126 1.7696 0.28V1.7696H0.28C0.126 1.7696 0 1.8956 0 2.0496C0 2.2036 0.126 2.3296 0.28 2.3296H1.7696V11.6704H0.28C0.126 11.6704 0 11.7964 0 11.9504C0 12.1044 0.126 12.2304 0.28 12.2304H1.7696V13.72C1.7696 13.874 1.8956 14 2.0496 14C2.2036 14 2.3296 13.874 2.3296 13.72V12.2304H11.6704V13.72C11.6704 13.874 11.7964 14 11.9504 14C12.1044 14 12.2304 13.874 12.2304 13.72V12.2304H13.72C13.874 12.2304 14 12.1044 14 11.9504C14 11.7964 13.874 11.6704 13.72 11.6704H12.2304V2.3296H13.72ZM2.3296 2.3296H11.6704V11.6704H2.3296V2.3296Z" fill={fill || 'black'} />
      </svg>

    </Icon>
  );
};

export default IconScreen;
